import React from 'react';
import { ellipse as TextEllipse } from 'library/helpers/text';
const curve = (t) => Math.exp(-t) * Math.cos(2 * Math.PI * t);
import EducationSvg from 'apps/pathways/icons/hand_graduation.svg';
import JobsSvg from 'apps/pathways/icons/hand_jobs.svg';
import Scroll from 'library/util/scroll';
import withUser from 'util/hoc/with-user';
import { resolve } from 'library/helpers/path-resolver';

const CalculateCurve = (fidelity, scale, start, amplitude, startX = 59.5, endX = 636.5) => {
  const out = [];
  for (var t = start, x = startX; x <= endX; t+=fidelity, x+=1) {
    out.push([
      x,
      parseFloat(curve((start + (x * fidelity)) * scale).toFixed(5) * amplitude)
    ].join(','));
  }
  return `M${out.join(' ')}`;
};

const ScrollToSection = (index) => {
  const targetElement = document.evaluate(`//*[@id="mount"]/div/div[2]/div[2]/section[${index+1}]`, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;

  if (targetElement) {
    const from = document.documentElement.scrollTop;
    const to = targetElement.getBoundingClientRect().top + document.documentElement.scrollTop;
    Scroll.go(from, to, 500, 'easeInOutQuad');
  }
};

const EndStep = ({ step, index, start, scale, fidelity, amplitude }) => (
  step ?
    <g className="pathway-overview-link" onClick={()=>ScrollToSection(index)} transform={`translate(${576.5},${parseFloat(curve((start + (576.5 * fidelity)) * scale).toFixed(5)) * amplitude - 8})`}>
      <StopIcon type={step.type} />
      <text fillOpacity="0.5" x={0} y={0} textAnchor={'middle'} fill="#fff" fontFamily="Lato" fontSize="8">
        { TextEllipse(step.title) }
      </text>
    </g> :
    null
);

const GetStopTextPosition = (total, index) => {
  if (total === 3) {
    if (index === 1) {
      return { x: 9, y: 24, a: 'middle' };
    } else if (index === 2) {
      return { x: 24, y: 12, a: 'start' };
    }
    return { x: 9, y: 0, a: 'middle' };
  } else if (total === 2) {
    if (index === 1) {
      return { x: 9, y: 24, a: 'middle' };
    }
    return { x: 5, y: 12, a: 'end' };
  }

  return { x: 24, y: 12, a: 'start' };
};

const StopIcon = ({ type }) => (
  type === 'Program'
    ? <EducationSvg alt="Education" width={22} height={22} style={{color: '#fff'}} />
    : <JobsSvg alt="Job" width={22} height={22} style={{color: '#fff'}} />
    // : <ellipse cx={12} cy={9} rx="5" ry="5" fill="transparent" stroke="#fff" strokeWidth="2" />
);

const Stop = ({ step, index, total, start, scale, fidelity, amplitude }) => {
  const t = (((576.5) / (total + 1)) * index) + 6.5;

  const { x, y, a } = GetStopTextPosition(total, index);
  return (
    <g className="pathway-overview-link" onClick={()=>ScrollToSection(index)} transform={`translate(${t},${parseFloat(curve((start + (t * fidelity)) * scale).toFixed(5)) * amplitude - 14})`}>
      <StopIcon type={step.type} />
      <text fillOpacity="0.5" x={x} y={y} textAnchor={a} fill="#fff" fontFamily="Lato" fontSize="8">
        { TextEllipse(step.title) }
      </text>
    </g>
  );
};

const Step = ({ index, x, y, step }) => {
  return (
    <g className="pathway-overview-link" onClick={()=>ScrollToSection(index)} transform={`translate(${x-9.5},${y-11.45})`}>
      <StopIcon type={step.type} />
      <text fillOpacity="0.5" x={9.5} y={30} textAnchor={'middle'} fill="#fff" fontFamily="Lato" fontSize="8">
        { TextEllipse(step.title) }
      </text>
    </g>
  );
}
const StartStep = ({ name, startName, index, x, y, step }) => {
  return (
    <g className="pathway-overview-link" onClick={()=>ScrollToSection(index)} transform={`translate(${x-9.5},${y-11.45})`}>
      <svg width="9.5" height="13" viewBox="0 0 19 26" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g fill="#F0BD1D">
          <path d="M9.5,1 C4.76428571,1 1,4.76155797 1,9.49384058 C1,15.8035507 9.5,25.2681159 9.5,25.2681159 C9.5,25.2681159 18,15.8035507 18,9.49384058 C18,4.76155797 14.2357143,1 9.5,1 L9.5,1 Z M9.5,12.5273551 C7.8,12.5273551 6.46428571,11.1926087 6.46428571,9.49384058 C6.46428571,7.79507246 7.8,6.46032609 9.5,6.46032609 C11.2,6.46032609 12.5357143,7.79507246 12.5357143,9.49384058 C12.5357143,11.1926087 11.2,12.5273551 9.5,12.5273551 L9.5,12.5273551 Z" id="Shape"></path>
        </g>
      </svg>
      <text fillOpacity={startName ? '0.75' : '0.5'} x={0} y={-11} textAnchor={'start'} fill="#fff" fontFamily="Lato" fontSize={startName ? '15' : '8'}>
        {  startName
          ? TextEllipse(name)
          : TextEllipse(step.title) }
      </text>
    </g>
  );
}

const TempStop = ({ x, y }) => (
  <circle r="20" cx={x} cy={y} />
);

const PathwayOverview = ({ user, startName = false, fidelity = 0.01, scale = 0.18, start = 3.54, amplitude = 143, steps = []}) => {

  const [start_step, ...other_steps] = steps;
  const end_step = other_steps.pop();

  const beginning = 59.5;
  const end = 634;

  const interval = (end - beginning) / (other_steps.length+1);

  if (!start_step || !end_step) {
    return null;
  }

  return (
    <div data-steps={other_steps.length} className={['pathway-overview', other_steps.length > 3 ? 'pathway-overview-hide-titles' : null].filter(c=>c).join(' ')}>
      <svg width="100%" height="auto" viewBox="0 0 700 10">
        <defs>
          <mask id="pathway-overview-mask">
            <rect x="0" y="-125" width={700} height={250} fill="#fff"></rect>
            <circle r="5" key={0} index={0} cx={beginning} cy={parseFloat(curve((start + (beginning * fidelity)) * scale).toFixed(5) * amplitude)} />
            {
              other_steps.map((s,i)=>{
                const x = ((i+1)*interval) + beginning;
                return <circle r="20" key={i} index={i} cx={x} cy={parseFloat(curve((start + (x * fidelity)) * scale).toFixed(5) * amplitude)} />;
              })
            }
            <circle r="20" key={steps.length-1} index={steps.length-1} cx={end} cy={parseFloat(curve((start + (end * fidelity)) * scale).toFixed(5) * amplitude)} />
          </mask>
        </defs>
        <g mask="url(#pathway-overview-mask)" strokeDasharray="10,8" strokeDashoffset="2" stroke="#F0BD1D" fill="transparent">
          <path d={CalculateCurve(fidelity, scale, start, amplitude, beginning, end)} />
        </g>
        <g>
          <StartStep name={resolve(user, 'first_name', 'You are here')} startName={startName} index={0} key={0} step={start_step} x={beginning} y={parseFloat(curve((start + (beginning * fidelity)) * scale).toFixed(5) * amplitude)} />
          {
            other_steps.map((s,i) => {
              const x = (i+1)*interval + beginning;
              return <Step key={i} index={i+1} step={s} x={x} y={parseFloat(curve((start + (x * fidelity)) * scale).toFixed(5) * amplitude)} />;
            })
          }
          <Step index={steps.length - 1} key={steps.length-1} step={end_step} x={end} y={parseFloat(curve((start + (end * fidelity)) * scale).toFixed(5) * amplitude)} />
        </g>
      </svg>
    </div>
  );
};

export default withUser(PathwayOverview);
